firebird.factory('connectivityService', [
    '$rootScope',
    '$window',
    '$timeout',
    'analyticsWrapperService',
    'desktopNotificationService',
    'helperService',
    'socketService',
    'logService',
    'storageService',
    'meetingService',
    'attendeeService',
    'attendeeListService',
    'supportLinkService',
    'localizationService',
    'connectivityStateService',
    'connectivityUpgradedService',
    'configService',
    'subscriptionService',
    function (
        $rootScope,
        $window,
        $timeout,
        analyticsWrapperService,
        desktopNotificationService,
        helperService,
        socketService,
        logService,
        storageService,
        meetingService,
        attendeeService,
        attendeeListService,
        supportLinkService,
        localizationService,
        connectivityStateService,
        connectivityUpgradedService,
        configService,
        subscriptionService
    ) {
        const logger = logService.createLoggerWithSource('connectivityService');

        //For MUX: FS member connected
        //For SFU: Janus Sip Call to FS connected
        var isFSMemberConnected = false;

        //MUX Only
        var isVertoConnected = false;

        //SFU Only
        var janusVideoPublisherIceState = 'unknown';
        var janusSipCallIceState = 'unknown';
        var janusWSConnected = false;

        var connectionType = null; //'verto' or 'janus'

        var isPhoneOnly = false;

        var nodeDisconnectedTime = null;
        var freeswitchDisconnectedTime = null;
        var iceDisconnectedTime = null;

        var mediumPLThreshold = 0.1; // 10%
        var audioHighPLThreshold = 0.25; // 25%
        var videoHighPLThreshold = 0.15; // 15%

        var slowLinkInterval = 5000; // aggregate slow link lost count within 5s.

        //Number of packets lost needed within an interval to consider as medium/high PL
        var slowLinkAudioThreshold = 3;
        var slowLinkVideoThreshold = 0;

        var firstPLStateCalculated = false;
        var consecutivePLStateCount = 0; //Number of times PL has been in a certain state (consecutively)
        var streams = {};

        var screenShareStreams = {
            sentVideo: {
                plState: 'untracked',
                plPercentage: '0%',
                totalPacketsLost: 0,
                totalPacketsTransmitted: 0
            }
        };

        var hdScreenShareStreams = {
            receivedVideo: {
                plState: 'untracked',
                plPercentage: '0%',
                totalPacketsLost: 0,
                totalPacketsTransmitted: 0
            }
        };

        //SFU
        var sfuStreams = {};
        var sfuReceivedVideoStreams = {};

        var localConnectivityStatus;
        var nodeConnectivityStatus;

        var iceServers = [];

        var audioThroughPhone = false;
        var audioChoice = null;
        var meetingState = '';
        var serverInitiatedDisconnect = false;

        var hdScreenShareCallPlisSent = 0; //Actual number of Plis sent
        var hdScreenShareCallPlisSentCounter = 0; //Number to determine how many times Plis sent has increased over a certain set of intervals

        var _hasLocalMediaEverBeenConnected = false;
        var isInDeviceSelectionFlow = false;

        var disconnectedBannerTimeout = null;
        var rootSubscription;
        let activeStreams = {};
        let packetLossState = 'low';

        var updateReconnectMessage = null;
        let disconnectBannerVisible = false;

        var service = {
            trackPacketLoss: trackPacketLoss,
            trackSlowLink: trackSlowLink,
            sendPLStateToServer: sendPLStateToServer,
            getPacketLossState: getPacketLossState,
            getOutboundPacketLossState: getOutboundPacketLossState,
            getScreenSharePLState: getScreenSharePLState,
            getPLStateCount: getPLStateCount,
            incrementPLStateCount: incrementPLStateCount,
            resetPLStateCountToOne: resetPLStateCountToOne,
            resetSentVideoPL: resetSentVideoPL,
            getStreams: getStreams,
            getRegularStreams: getRegularStreams,
            getOutboundStreams: getOutboundStreams,
            getScreenShareStreams: getScreenShareStreams,
            setVertoConnected: setVertoConnected,
            getConferenceConnected: getConferenceConnected,
            setFSMemberConnected: setFSMemberConnected,
            getFSMemberConnected: getFSMemberConnected,
            getVertoConnected: getVertoConnected,
            getAudioThroughPhone: getAudioThroughPhone,
            setAudioThroughPhone: setAudioThroughPhone,
            setMeetingState: setMeetingState,
            getMeetingState: getMeetingState,
            setConnectionType: setConnectionType,
            getConnectionType: getConnectionType,
            setServerInitiatedDisconnect: setServerInitiatedDisconnect,
            getServerInitiatedDisconnect: getServerInitiatedDisconnect,
            getConnectivityTooltip: getConnectivityTooltip,
            getConnectivityIconState: getConnectivityIconState,
            getLocalConnectivityIconState: getLocalConnectivityIconState,
            setLocalConnectivityState: setLocalConnectivityState,
            isLocalConnectvityConnected: isLocalConnectvityConnected,
            getLocalConnectivityState: getLocalConnectivityState,
            hasLocalMediaEverBeenConnected: hasLocalMediaEverBeenConnected,
            sendIceConnStateToServer: sendIceConnStateToServer,
            setIceServers: setIceServers,
            getIceServers: getIceServers,
            setPhoneOnlyState: setPhoneOnlyState,
            getIsPhoneOnly: getIsPhoneOnly,

            setInitialAudioChoice: setInitialAudioChoice,
            getInitialAudioChoice: getInitialAudioChoice,

            //HD ScreenShare
            setHDScreenSharePlisSent: setHDScreenSharePlisSent,
            getHDScreenSharePlisSent: getHDScreenSharePlisSent,
            getHDScreenSharePlisSentCounter: getHDScreenSharePlisSentCounter,
            incrementHDScreenSharePlisSentCounter: incrementHDScreenSharePlisSentCounter,
            resetHDScreenSharePlisSentCounter: resetHDScreenSharePlisSentCounter,
            getHDScreenShareStreams: getHDScreenShareStreams,

            //Stun Keepalive Tracking
            trackStunRequests: trackStunRequests,
            resetStunTrackingData: resetStunTrackingData,
            callMediaTypes: {
                VERTO: 0,
                SCREENSHARE: 1,
                HD_SCREENSHARE: 2,
                SFU: 3,
                SFU_RECEIVED_VIDEO: 4
            },
            activeVertoCandidateId: null,
            activeScreenShareCandidateId: null,
            vertoStunKeepaliveCounter: {
                requestsSent: 0,
                responsesReceived: 0
            },
            screenShareStunKeepaliveCounter: {
                requestsSent: 0,
                responsesReceived: 0
            },

            getSfuStreams: getSfuStreams,
            getSfuReceivedVideoStreamsList: getSfuReceivedVideoStreamsList,
            addToSfuReceivedVideoStreamsList: addToSfuReceivedVideoStreamsList,
            getSfuReceivedVideoStreamsAggregate: getSfuReceivedVideoStreamsAggregate,
            resetSfuReceivedVideoStats: resetSfuReceivedVideoStats,

            getNumericPlPercentage: getNumericPlPercentage,
            determineNewPLStateAndSendToServer: determineNewPLStateAndSendToServer,

            getJanusVideoPublisherIceState: getJanusVideoPublisherIceState,
            getJanusSipCallIceState: getJanusSipCallIceState,
            getJanusWSConnected: getJanusWSConnected,
            updateJanusIceState: updateJanusIceState,

            showDisconnectedBanner: showDisconnectedBanner,
            hideDisconnectedBanner: hideDisconnectedBanner,
            showFsOriginDisconnectedBanner: showFsOriginDisconnectedBanner,
            hideFsOriginDisconnectedBanner: hideFsOriginDisconnectedBanner,
            cancelDisconnectBannerTimeout: cancelDisconnectBannerTimeout,
            getIsInDeviceSelectionFlow: getIsInDeviceSelectionFlow,
            setIsInDeviceSelectionFlow: setIsInDeviceSelectionFlow,
            setFsOriginConnectionProblem: setFsOriginConnectionProblem,
            getNodeConnectivityState: getNodeConnectivityState,
            disconnectAudioInputAndOutput: disconnectAudioInputAndOutput,
            updateDisconnectBannerVisible: updateDisconnectBannerVisible,
            getDisconnectBannerVisible: getDisconnectBannerVisible,
            getUpdatedBannerState: getUpdatedBannerState
        };

        initSubscriptions();

        //for freeswitch, there are 2 connections. 1 for socket and 1 for freeswitch media stream
        //in the case of socket disconnect,
        $rootScope.$on('fs-ws-disconnected', onFsWsDisconnected);
        $rootScope.$on('fs-ws-connected', onFsWsConnected);
        $rootScope.$on('fs-ws-gave-up', onFsWsGaveUp);

        $rootScope.$on('fs-origin-disconnected', onFsOriginDisconnected);
        $rootScope.$on('fs-origin-connected', onFsOriginConnected);

        // use the same functions for SFU, either FS or SFU but not both will be used.
        $rootScope.$on('sfu-ws-disconnected', onFsWsDisconnected);
        $rootScope.$on('sfu-ws-connected', onFsWsConnected);
        $rootScope.$on('sfu-ws-gave-up', onFsWsGaveUp);

        $rootScope.$on('sfu-sip-disconnected', onFsWsDisconnected);
        $rootScope.$on('sfu-sip-connected', onFsWsConnected);
        $rootScope.$on('sfu-sip-gave-up', onFsWsGaveUp);

        $rootScope.$on('node-connected', onNodeConnected);
        $rootScope.$on('node-reconnected', onNodeReconnected);
        $rootScope.$on('node-disconnected', onNodeDisconnected);

        $rootScope.$on('ice-servers', onIceServersReceived);

        $rootScope.$on('hide-modal', onHideModal);
        $rootScope.$on('$destroy', onScopeDestroyed);

        $rootScope.$on('enable-compact-mode', onCompactModeReceived);

        $rootScope.$on('update-meeting-active-feed', onUpdateMeetingActiveFeed);

        let isCompactMode = false;

        return service;

        ////////////////////////

        function getAudioThroughPhone() {
            return audioThroughPhone;
        }

        function setAudioThroughPhone(flag, saveToStorage) {
            var valueChanged = audioThroughPhone !== flag;
            audioThroughPhone = flag;

            //Mutes audio output from audio and video feeds
            if (meetingService.getIsSfuEnabled()) {
                $window.$('#videoroom-sipaudio').prop('muted', flag);
                //SFU video feeds do not have audio enabled, so no need to mute them here
            } else {
                $window.$('#videoFeed').prop('muted', flag);
                $window.$('#audioFeed').prop('muted', flag);
            }

            //Only want to send this if the value changed,
            //to prevent unnecessary events being broadcasted
            if (valueChanged) {
                logger.log('Updating Audio-Through-Phone state to:', audioThroughPhone);
                $rootScope.$broadcast('phone-state-updated');

                //Only attempt to deaf if connected to FS
                if (service.getFSMemberConnected()) {
                    attendeeService.setAudioDeaf(audioThroughPhone);
                }
                updateDisconnectBannerVisible();
            }

            if (saveToStorage) {
                storageService.set('using-phone-for-audio', audioThroughPhone);
            }
        }

        function disconnectAudioInputAndOutput(flag) {
            if (meetingService.e2eeEnabled()) {
                $window.$('#videoroom-videos > div.remote > video').each(function (index, element) {
                    element.muted = flag;
                });
            }
            $window.$('#videoroom-sipaudio').prop('muted', flag);
            $rootScope.$broadcast('update-local-audio-state');
            if (service.getFSMemberConnected()) {
                attendeeService.setAudioDeaf(flag);
            }
        }

        function onNodeConnected() {
            //TODO: decide if we need to do anything here
            nodeConnectivityStatus = 'connected';
        }

        function onNodeReconnected() {
            nodeConnectivityStatus = 'connected';
            if (service.getConferenceConnected()) {
                logger.log('connectivityService - Node reconnected... dismissing banner');
                updateDisconnectBannerVisible();
                var nodeEventToTrack = {
                    category: 'node reconnected'
                };
                if (nodeDisconnectedTime) {
                    var nodeReconnectedTime = new Date().getTime();
                    var nodeReconnectTimeDifference = nodeReconnectedTime - nodeDisconnectedTime;
                    var nodeReconnectTimeConversionToSeconds = nodeReconnectTimeDifference / 1000;
                    nodeEventToTrack.duration = nodeReconnectTimeConversionToSeconds;
                    logger.log(
                        'meeting - node reconnected after: ' + nodeReconnectTimeConversionToSeconds + ' seconds'
                    );
                }
                analyticsWrapperService.eventTrack(
                    'meeting - node socket connection - client reconnected to the node server',
                    nodeEventToTrack
                );
            }
        }

        function onNodeDisconnected() {
            nodeConnectivityStatus = 'disconnected';
            if (meetingState !== 'ending' && !serverInitiatedDisconnect && !service.getIsInDeviceSelectionFlow()) {
                nodeDisconnectedTime = new Date().getTime();

                analyticsWrapperService.eventTrack(
                    'meeting - node socket connection - client disconnected from the node server',
                    {
                        category: 'node disconnected'
                    }
                );
            }
            updateDisconnectBannerVisible();
        }

        function onFsWsDisconnected() {
            if (meetingState !== 'ending' && !serverInitiatedDisconnect && !service.getIsInDeviceSelectionFlow()) {
                freeswitchDisconnectedTime = new Date().getTime();
                analyticsWrapperService.eventTrack(
                    'meeting - freeswitch socket connection - client disconnected from the freeswitch server',
                    {
                        category: 'freeswitch disconnected'
                    }
                );
            }

            janusWSConnected = false;
            updateDisconnectBannerVisible();
        }

        function onFsWsConnected() {
            if (socketService.isConnected()) {
                var freeswitchEventToTrack = {
                    category: 'freeswitch reconnected'
                };
                if (freeswitchDisconnectedTime) {
                    var freeswitchReconnectedTime = new Date().getTime();
                    var fsReconnectTimeDifference = freeswitchReconnectedTime - freeswitchDisconnectedTime;
                    var fsReconnectTimeConversionToSeconds = fsReconnectTimeDifference / 1000;
                    freeswitchEventToTrack.duration = fsReconnectTimeConversionToSeconds;
                    logger.log(
                        'meeting - freeswitch has reconnected after: ' + fsReconnectTimeConversionToSeconds + ' seconds'
                    );
                }
                analyticsWrapperService.eventTrack(
                    'meeting - freeswitch socket connection - client reconnected to the freeswitch server',
                    freeswitchEventToTrack
                );
            }
            janusWSConnected = true;
            updateDisconnectBannerVisible();
        }

        function onFsWsGaveUp() {
            $rootScope.$broadcast('banner-message-show', {
                header: localizationService.translate('WEBINAR_STATUS_BAR.CHECK_CONNECTION.TITLE'),
                content: localizationService.translate('WEBINAR_STATUS_BAR.CHECK_CONNECTION.CONTENT')
            });
            analyticsWrapperService.eventTrack('meeting - banner message - gave up trying to connect to meeting', {
                category: 'banner message'
            });
        }

        function onFsOriginConnected() {
            service.hideFsOriginDisconnectedBanner();
        }

        function onFsOriginDisconnected() {
            service.showFsOriginDisconnectedBanner();
        }

        function resetStunTrackingData(callMediaType) {
            if (callMediaType === service.callMediaTypes.VERTO) {
                logger.log('Verto - Stun Keepalive - Resetting Tracking Data');
                service.activeVertoCandidateId = null;
                service.vertoStunKeepaliveCounter.requestsSent = 0;
                service.vertoStunKeepaliveCounter.responsesReceived = 0;
            } else if (callMediaType === service.callMediaTypes.SCREENSHARE) {
                logger.log('ScreenShare - Stun Keepalive - Resetting Tracking Data');
                service.activeScreenShareCandidateId = null;
                service.screenShareStunKeepaliveCounter.requestsSent = 0;
                service.screenShareStunKeepaliveCounter.responsesReceived = 0;
            }
        }

        function trackStunRequests(r, callMediaType) {
            var activeCandidateId;
            var counter;
            var callTypeLabel;

            if (callMediaType === service.callMediaTypes.VERTO) {
                callTypeLabel = 'Verto';
                activeCandidateId = service.activeVertoCandidateId;
                counter = service.vertoStunKeepaliveCounter;
            } else if (callMediaType === service.callMediaTypes.SCREENSHARE) {
                callTypeLabel = 'ScreenShare';
                activeCandidateId = service.activeScreenShareCandidateId;
                counter = service.screenShareStunKeepaliveCounter;
            }

            if (activeCandidateId) {
                if (r.type === 'localcandidate' && r.id === activeCandidateId) {
                    try {
                        var newStunKeepaliveRequestsSent = parseInt(r.stunKeepaliveRequestsSent);
                        var newStunKeepaliveResponsesReceived = parseInt(r.stunKeepaliveResponsesReceived);

                        var requestsSentDiff = newStunKeepaliveRequestsSent - counter.requestsSent;
                        var responsesReceivedDiff = newStunKeepaliveResponsesReceived - counter.responsesReceived;

                        if (requestsSentDiff > 0 && requestsSentDiff > responsesReceivedDiff) {
                            analyticsWrapperService.eventTrack(
                                callTypeLabel + " - Stun Keepalive - Experienced drop in 'Responses Received'"
                            );
                            logger.log(
                                callTypeLabel +
                                    ' - Stun Keepalive - Requests Sent since last interval: ' +
                                    requestsSentDiff +
                                    ', Responses Received since last interval: ' +
                                    responsesReceivedDiff
                            );
                        }

                        counter.requestsSent = newStunKeepaliveRequestsSent;
                        counter.responsesReceived = newStunKeepaliveResponsesReceived;
                    } catch (e) {
                        logger.log('Error parsing ' + callTypeLabel + ' candidate keepalive requests', e);
                    }
                }
            } else {
                var candidatePair = r.type === 'googCandidatePair';
                var activeConnection = r.googActiveConnection === 'true';
                var videoChannel = r.id && r.id.indexOf('video') > -1;

                if (candidatePair && activeConnection && videoChannel) {
                    logger.log(callTypeLabel + ' - Stun Keepalive - Active ICE Candidate Found:', r.localCandidateId);

                    if (callMediaType === service.callMediaTypes.VERTO) {
                        service.activeVertoCandidateId = r.localCandidateId;
                    } else if (callMediaType === service.callMediaTypes.SCREENSHARE) {
                        service.activeScreenShareCandidateId = r.localCandidateId;
                    }
                }
            }
        }

        // notCumulative is only from videoroomCtrl when fixStatsIn117 is set.
        function trackPacketLoss(streamStats, mediaType, transmissionType, callMediaType, notCumulative) {
            if (!service.getFSMemberConnected()) {
                return;
            }

            var key = transmissionType + capitalizeFirstLetter(mediaType); //i.e. sentAudio

            var streamsObj;
            var label;
            switch (callMediaType) {
                case service.callMediaTypes.VERTO:
                    streamsObj = service.getRegularStreams();
                    label = 'Main Verto Call';
                    break;
                case service.callMediaTypes.SCREENSHARE:
                    streamsObj = screenShareStreams;
                    label = 'ScreenShare Sender';
                    break;
                case service.callMediaTypes.HD_SCREENSHARE:
                    streamsObj = hdScreenShareStreams;
                    label = 'HD ScreenShare Viewer';
                    break;
                case service.callMediaTypes.SFU:
                    streamsObj = service.getSfuStreams();
                    label = 'SFU';
                    break;
                case service.callMediaTypes.SFU_RECEIVED_VIDEO:
                    streamsObj = service.getSfuStreams();
                    label = 'SFU Received Video';
                    break;
            }

            if (!streamsObj) {
                return;
            }

            //curStream could be sentAudio, receivedVideo, etc.
            var curStream = streamsObj[key];

            // update slowLinkLastTime if needed
            if (
                curStream &&
                (callMediaType == service.callMediaTypes.SFU ||
                    callMediaType == service.callMediaTypes.SFU_RECEIVED_VIDEO)
            ) {
                var now = new Date().getTime();
                if (curStream.slowLinkLastTime && now - curStream.slowLinkLastTime > slowLinkInterval) {
                    curStream.slowLinkLastTime = 0;
                    curStream.slowLinkLostCount = 0;
                }
            }

            try {
                var curPacketsLost = parseInt(streamStats.packetsLost || 0); //For Firefox, outbound streams do not include packetsLost property
                if (curPacketsLost < 0) {
                    curPacketsLost = 0;
                }

                var curPacketsTransmitted =
                    transmissionType === 'sent'
                        ? parseInt(streamStats.packetsSent)
                        : parseInt(streamStats.packetsReceived);
                curPacketsTransmitted += curPacketsLost;

                //trackPacketLoss() gets called every 5 seconds, for each of the 4 streams.
                //
                //For a more accurate tracking, we take the amount of packets LOST in the last 5 seconds
                //and divide by the TOTAL packets sent in the last 5 seconds (hence the 'delta' logic below)
                var packetsLostDelta = notCumulative ? curPacketsLost : curPacketsLost - curStream.totalPacketsLost;
                if (!notCumulative) {
                    curStream.totalPacketsLost = curPacketsLost;
                }

                var packetsTransmittedDelta = notCumulative
                    ? curPacketsTransmitted
                    : curPacketsTransmitted - curStream.totalPacketsTransmitted;
                if (!notCumulative) {
                    curStream.totalPacketsTransmitted = curPacketsTransmitted;
                }

                //Any deltas that are 0 will result in NaN, so we default to 0 in these cases
                var packetLossPercentage = packetsLostDelta / packetsTransmittedDelta || 0;
                if (packetLossPercentage === Infinity) {
                    return;
                } else if (packetLossPercentage > 1) {
                    packetLossPercentage = 1;
                }

                var packetLossPercentageString = convertToPercentageString(packetLossPercentage);
                curStream.plPercentage = packetLossPercentageString;

                if (
                    (mediaType !== 'audio' && packetLossPercentage > videoHighPLThreshold) ||
                    packetLossPercentage > audioHighPLThreshold
                ) {
                    logger.warn(
                        'trackPacketLoss',
                        label + ' - ' + transmissionType + ' ' + mediaType + ' - Experiencing high packet loss',
                        packetLossPercentageString
                    );
                    curStream.plState = 'high';
                    curStream.showPlData = true;
                } else if (packetLossPercentage > mediumPLThreshold) {
                    curStream.plState = 'medium';
                    curStream.showPlData = true;
                } else {
                    curStream.plState = 'low';
                    curStream.showPlData = false;
                }

                switch (callMediaType) {
                    case service.callMediaTypes.VERTO:
                        connectivityStateService.streams = streamsObj;
                        break;
                    case service.callMediaTypes.SFU:
                    case service.callMediaTypes.SFU_RECEIVED_VIDEO:
                        connectivityStateService.sfuStreams = streamsObj;
                        break;
                    default:
                        break;
                }
            } catch (e) {
                logger.error('trackPacketLoss', 'Error', e);
            }
        }

        // only for SFU, when slow link event is received for audio send/receive, video send/receive or screen send.
        function trackSlowLink(mediaType, transmissionType, lostCount) {
            var streamsObj = service.getSfuStreams();

            if (!streamsObj) {
                logger.warn('trackSlowLink', 'Invalid streamsObj... returning');
                return;
            }

            var key;

            try {
                key = transmissionType + capitalizeFirstLetter(mediaType); //i.e. sentAudio
            } catch (e) {
                logger.error('trackSlowLink', 'Unable to derive key', e);
                return;
            }

            //curStream could be sentAudio, receivedVideo, etc.
            var curStream = streamsObj[key];
            if (curStream) {
                var initialPLState = service.getOutboundPacketLossState();

                // aggregate until no slow link for 5 seconds.
                var now = new Date().getTime();
                if (now - curStream.slowLinkLastTime > slowLinkInterval) {
                    curStream.slowLinkLostCount = lostCount;
                } else {
                    curStream.slowLinkLostCount += lostCount;
                }
                curStream.slowLinkLastTime = now;

                connectivityStateService.sfuStreams = streamsObj;
                service.determineNewPLStateAndSendToServer(initialPLState);
            } else {
                logger.warn('trackSlowLink', 'Invalid stream. Key:', key);
            }
        }

        function sendPLStateToServer(newPLState) {
            if (!service.getFSMemberConnected()) {
                return;
            }

            $rootScope.$broadcast('attendee-connectivity-state-changed');

            socketService.send({
                message: 'attendee-connectivity-updated',
                data: {
                    packetLoss: {
                        state: newPLState,
                        streams: service.getOutboundStreams()
                    }
                }
            });
        }

        // moved to connectivity.service.ts
        function getPacketLossState() {
            return packetLossState;
        }

        function getOutboundPacketLossState() {
            var outboundPacketLossState = 'low';

            var curStreams = service.getStreams();

            if (curStreams.sentAudio.plState === 'medium' || curStreams.sentVideo.plState === 'medium') {
                outboundPacketLossState = 'medium';
            }

            if (curStreams.sentAudio.plState === 'high' || curStreams.sentVideo.plState === 'high') {
                outboundPacketLossState = 'high';
            }

            if (outboundPacketLossState === 'low') {
                if (
                    curStreams.sentAudio.slowLinkLostCount > slowLinkAudioThreshold ||
                    curStreams.sentVideo.slowLinkLostCount > slowLinkVideoThreshold
                ) {
                    outboundPacketLossState = 'medium';
                }
            }

            return outboundPacketLossState;
        }

        function getScreenSharePLState() {
            var packetLossState = 'low';

            if (screenShareStreams.sentVideo.plState === 'medium') {
                packetLossState = 'medium';
            }

            if (screenShareStreams.sentVideo.plState === 'high') {
                packetLossState = 'high';
            }

            return packetLossState;
        }

        function getPLStateCount() {
            return consecutivePLStateCount;
        }

        function incrementPLStateCount() {
            consecutivePLStateCount++;
        }

        function resetPLStateCountToOne() {
            consecutivePLStateCount = 1;
        }

        function resetSentVideoPL() {
            const initialPLState = service.getOutboundPacketLossState();
            const existingSfuStreams = service.getSfuStreams();
            existingSfuStreams.sentVideo = {
                plState: 'untracked',
                plPercentage: '0%',
                totalPacketsLost: 0,
                totalPacketsTransmitted: 0,
                slowLinkLostCount: 0,
                slowLinkLastTime: 0,
                showPlData: false
            };

            connectivityStateService.sfuStreams = existingSfuStreams;
            service.determineNewPLStateAndSendToServer(initialPLState);
        }

        //PLI = Picture Loss Indication
        function setHDScreenSharePlisSent(newPlisSent) {
            if (newPlisSent) {
                hdScreenShareCallPlisSent = newPlisSent;
            }
        }

        function getHDScreenSharePlisSent() {
            return hdScreenShareCallPlisSent;
        }

        function getHDScreenSharePlisSentCounter() {
            return hdScreenShareCallPlisSentCounter;
        }

        function incrementHDScreenSharePlisSentCounter() {
            hdScreenShareCallPlisSentCounter++;
        }

        function resetHDScreenSharePlisSentCounter() {
            hdScreenShareCallPlisSentCounter = 0;
        }

        function getHDScreenShareStreams() {
            return hdScreenShareStreams;
        }

        // moved to connectivity.service.ts
        function getStreams() {
            // active streams represent sfuStreams or streams depends on sfuEnabled
            return activeStreams;
        }

        function getRegularStreams() {
            return streams;
        }

        function getOutboundStreams() {
            return {
                sentAudio: service.getStreams().sentAudio,
                sentVideo: service.getStreams().sentVideo
            };
        }

        function getScreenShareStreams() {
            return screenShareStreams;
        }

        function getSfuStreams() {
            return sfuStreams;
        }

        function getSfuReceivedVideoStreamsList() {
            return sfuReceivedVideoStreams;
        }

        function addToSfuReceivedVideoStreamsList(key, value) {
            sfuReceivedVideoStreams[key] = value;
        }

        function getSfuReceivedVideoStreamsAggregate() {
            const streams = service.getSfuReceivedVideoStreamsList(); //key-value list of all active sfu received video streams

            const receivedVideoStatsAggregateObj = {
                packetsLost: 0,
                packetsReceived: 0
            };

            if (!streams || Object.keys(streams).length === 0) {
                return receivedVideoStatsAggregateObj;
            }

            let packetsLostSum = 0;
            let packetsReceivedSum = 0;

            try {
                for (let key in streams) {
                    packetsLostSum += parseInt(streams[key].packetsLost);
                    packetsReceivedSum += parseInt(streams[key].packetsReceived);
                }
            } catch (e) {
                logger.error(
                    'getSfuReceivedVideoStreamsAggregate',
                    'Error calculating received video streams PL aggregate',
                    e
                );
            }

            receivedVideoStatsAggregateObj.packetsLost = packetsLostSum;
            receivedVideoStatsAggregateObj.packetsReceived = packetsReceivedSum;

            return receivedVideoStatsAggregateObj;
        }

        function resetSfuReceivedVideoStats() {
            const existingSfuStreams = service.getSfuStreams();
            existingSfuStreams.receivedVideo = {
                plState: 'low',
                plPercentage: '0%',
                totalPacketsLost: 0,
                totalPacketsTransmitted: 0
            };
            connectivityStateService.sfuStreams = existingSfuStreams;
        }

        function getNumericPlPercentage(plPercentage) {
            var percentageFloat = null;

            try {
                var percentageString = parseFloat(plPercentage.replace('%', '')).toFixed(2);
                percentageFloat = parseFloat(percentageString);
            } catch (e) {
                logger.error('getNumericPlPercentage', 'Unable to parse PL percentage', e);
            }

            return percentageFloat;
        }

        function determineNewPLStateAndSendToServer(initialPLState) {
            var newPLState = service.getOutboundPacketLossState();

            //If PL State Changes, count gets reset to 1...
            //otherwise, increment as normal
            if (initialPLState === newPLState) {
                service.incrementPLStateCount();
            } else {
                service.resetPLStateCountToOne();
            }

            //Number of times PL has been in a certain state (consecutively)
            var plStateCount = service.getPLStateCount();

            if (plStateCount === 2) {
                var ignoreState = false;

                //If first PL state calculation is "low", do not log or send state to server
                if (!firstPLStateCalculated) {
                    firstPLStateCalculated = true;
                    ignoreState = newPLState === 'low';
                }

                if (!ignoreState) {
                    logger.log('Packet Loss State changing to:', newPLState);
                    analyticsWrapperService.eventTrack('Meeting - Packet Loss State - ' + newPLState);

                    service.sendPLStateToServer(newPLState);
                }
            } else if (plStateCount > 2 && newPLState !== 'low') {
                //If PL state is medium or high, we still want to keep updating server
                //with current PL percentages (we show these stats in attendee list tooltips)
                service.sendPLStateToServer(newPLState);
            }
        }

        function setVertoConnected(newVertoConnectedState) {
            isVertoConnected = newVertoConnectedState ? true : false;
        }

        function getConferenceConnected() {
            var confConnected;

            switch (connectionType) {
                case 'janus':
                    confConnected =
                        isFSMemberConnected &&
                        (janusSipCallIceState === 'connected' || janusSipCallIceState === 'completed');

                    break;
                case 'verto':
                    confConnected = isFSMemberConnected && isVertoConnected;
                    break;
                default:
                    confConnected = false;
                    // logger.log('Unknown connection type:', connectionType);
                    break;
            }

            return confConnected;
        }

        function getNodeConnectivityState() {
            return nodeConnectivityStatus;
        }

        function setFSMemberConnected(newFsMemberConnected) {
            isFSMemberConnected = newFsMemberConnected;
        }

        function getFSMemberConnected() {
            return isFSMemberConnected;
        }

        function getVertoConnected() {
            return isVertoConnected;
        }

        function hasLocalMediaEverBeenConnected() {
            return _hasLocalMediaEverBeenConnected;
        }

        function setLocalConnectivityState(iceState, janusSocketState) {
            let newLocalConnectivityStatus;
            switch (iceState) {
                case 'new':
                case 'checking':
                case 'connecting':
                case 'unassigned':
                    newLocalConnectivityStatus = 'connecting';
                    break;

                case 'connected':
                case 'completed':
                    if (janusSocketState === 'connected') {
                        connectivityStateService.hasLocalMediaEverBeenConnected = true;
                        newLocalConnectivityStatus = 'connected';
                    } else {
                        newLocalConnectivityStatus = 'connecting';
                    }
                    break;

                default:
                    newLocalConnectivityStatus = 'disconnected';
            }

            connectivityStateService.localConnectivityStatus = newLocalConnectivityStatus;

            logger.log(
                'Connectivity Service localConnectivity state changed - ICE state: ' +
                    iceState +
                    ' (' +
                    newLocalConnectivityStatus +
                    ')'
            );
        }

        function isLocalConnectvityConnected() {
            return service.getLocalConnectivityState() === 'connected';
        }

        function getLocalConnectivityState() {
            return localConnectivityStatus;
        }

        function showFsOriginDisconnectedBanner() {
            if (updateReconnectMessage === null) {
                updateReconnectMessage = configService.getValue('updateReconnectMessage') === 'true';
            }
            var disconnectedBannerHeader = localizationService.translate(
                updateReconnectMessage
                    ? 'HEADER.NOTIFICATIONS.NEW_DISCONNECTED_FROM_MEETING'
                    : 'HEADER.NOTIFICATIONS.DISCONNECTED_FROM_MEETING'
            );
            var disconnectedBannerContent = updateReconnectMessage
                ? ' '
                : localizationService.translate('HEADER.NOTIFICATIONS.PLEASE_WAIT_RECONNECT');

            $rootScope.$broadcast('banner-message-show', {
                header: disconnectedBannerHeader,
                content: disconnectedBannerContent,
                key: 'fs-origin-connection'
            });
        }

        function hideFsOriginDisconnectedBanner() {
            $rootScope.$broadcast('banner-message-dismiss', { key: 'fs-origin-connection' });
        }

        function showDisconnectedBanner() {
            if (!disconnectedBannerTimeout) {
                if (updateReconnectMessage === null) {
                    updateReconnectMessage = configService.getValue('updateReconnectMessage') === 'true';
                }
                var disconnectedBannerHeader = localizationService.translate(
                    updateReconnectMessage
                        ? 'HEADER.NOTIFICATIONS.NEW_DISCONNECTED_FROM_MEETING'
                        : 'HEADER.NOTIFICATIONS.DISCONNECTED_FROM_MEETING'
                );
                var disconnectedBannerContent = updateReconnectMessage
                    ? ' '
                    : localizationService.translate('HEADER.NOTIFICATIONS.PLEASE_WAIT_RECONNECT');

                disconnectedBannerTimeout = $timeout(function () {
                    disconnectedBannerTimeout = null;

                    $rootScope.$broadcast('banner-message-show', {
                        header: disconnectedBannerHeader,
                        content: disconnectedBannerContent
                    });

                    analyticsWrapperService.eventTrack('meeting - banner message - disconnected from meeting', {
                        category: 'banner message'
                    });

                    if (
                        helperService.isBrowserInFocus() === false &&
                        meetingService.isWebinar() === false &&
                        !isCompactMode
                    ) {
                        desktopNotificationService.show(disconnectedBannerHeader + ' ' + disconnectedBannerContent);
                    }
                }, 10000);
            }
        }

        function hideDisconnectedBanner() {
            service.cancelDisconnectBannerTimeout();
            $rootScope.$broadcast('banner-message-dismiss');
        }

        function cancelDisconnectBannerTimeout() {
            if (disconnectedBannerTimeout) {
                $timeout.cancel(disconnectedBannerTimeout);
                disconnectedBannerTimeout = null;
            }
        }

        function setMeetingState(newState) {
            meetingState = newState;
        }

        function getMeetingState() {
            return meetingState;
        }

        function setConnectionType(newConnectionType) {
            connectionType = newConnectionType;
        }

        function getConnectionType() {
            return connectionType;
        }

        function setServerInitiatedDisconnect(flag) {
            serverInitiatedDisconnect = flag;
        }

        function getServerInitiatedDisconnect() {
            return serverInitiatedDisconnect;
        }

        // moved to connectivity.service.ts
        function getConnectivityTooltip(connectivityObj, isSelf, firstName) {
            if (
                !(connectivityObj && connectivityObj.iceConnectionState && connectivityObj.packetLoss) ||
                !(isSelf || firstName)
            ) {
                return;
            }

            var tooltip = '';
            var meetingType = meetingService.getLocalizedMeetingType();
            switch (connectivityObj.iceConnectionState) {
                case 'new':
                case 'checking':
                case 'connecting':
                case 'unassigned':
                    tooltip = isSelf
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_PROGRESS_YOU_CONNECTING', {
                              meeting_type: meetingType
                          })
                        : localizationService.translate(
                              'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_PROGRESS_PERSON_CONNECTING',
                              { person: firstName, meeting_type: meetingType }
                          );
                    break;

                case 'connected':
                case 'completed':
                    var pl = connectivityObj.packetLoss;

                    if (pl.state === 'low') {
                        tooltip = isSelf
                            ? localizationService.translate(
                                  'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_PROGRESS_YOU_HAVE_GOOD_CONNECTION'
                              )
                            : localizationService.translate(
                                  'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_PROGRESS_PERSON_HAVE_GOOD_CONNECTION',
                                  { person: firstName }
                              );
                    } else {
                        //Packet loss
                        if (pl.state === 'high') {
                            tooltip = isSelf
                                ? localizationService.translate(
                                      'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_YOU_HAVE_HIGH_PACKET_LOSS'
                                  )
                                : localizationService.translate(
                                      'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_PERSON_HAVE_HIGH_PACKET_LOSS',
                                      { person: firstName }
                                  );
                        } else {
                            tooltip = isSelf
                                ? localizationService.translate(
                                      'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_YOU_HAVE_LOW_PACKET_LOSS'
                                  )
                                : localizationService.translate(
                                      'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_PERSON_HAVE_LOW_PACKET_LOSS',
                                      { person: firstName }
                                  );
                        }

                        //showPlData flag will be true if medium/high PL state was detected via getStats only (we won't show stats if only slowlink is detected)
                        for (var key in pl.streams) {
                            var curStream = pl.streams[key];
                            if (curStream.showPlData) {
                                if (key.toLowerCase().indexOf('sent') > -1) {
                                    tooltip += '\n';
                                    tooltip +=
                                        key.toLowerCase().indexOf('audio') > -1
                                            ? localizationService.translate(
                                                  'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_MEDIA_AUDIO_SENT_LOSS',
                                                  { percentage: curStream.plPercentage }
                                              )
                                            : localizationService.translate(
                                                  'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_MEDIA_VIDEO_SENT_LOSS',
                                                  { percentage: curStream.plPercentage }
                                              );
                                } else {
                                    tooltip += '\n';
                                    tooltip +=
                                        key.toLowerCase().indexOf('audio') > -1
                                            ? localizationService.translate(
                                                  'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_MEDIA_AUDIO_RECEIVED_LOSS',
                                                  { percentage: curStream.plPercentage }
                                              )
                                            : localizationService.translate(
                                                  'ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_MEDIA_VIDEO_RECEIVED_LOSS',
                                                  { percentage: curStream.plPercentage }
                                              );
                                }
                            }
                        }
                    }
                    break;

                default:
                    tooltip = isSelf
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_YOU_ARE_NOT_CONNECTED', {
                              meeting_type: meetingType
                          })
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.CONNECTIVITY_PERSON_ARE_NOT_CONNECTED', {
                              person: firstName,
                              meeting_type: meetingType
                          });
            }

            return tooltip;
        }

        function getLocalConnectivityIconState() {
            var connectivityIconState;

            switch (service.getPacketLossState()) {
                case 'low':
                    connectivityIconState = 'low';
                    break;
                //ANYAM-70745 removes pl Icon for medium pl, this ticket specifies to not remove any medium pl logic.
                case 'medium':
                    connectivityIconState = 'low';
                    break;
                case 'high':
                    connectivityIconState = 'high';
                    break;
                default:
                    connectivityIconState = 'low';
            }

            return connectivityIconState;
        }

        function getConnectivityIconState(attendeeConnectivityObj) {
            var connectivityIconState;

            switch (attendeeConnectivityObj.packetLoss.state) {
                case 'low':
                    connectivityIconState = 'low';
                    break;
                //ANYAM-70745 removes pl Icon for medium pl, this ticket specifies to not remove any medium pl logic
                case 'medium':
                    connectivityIconState = 'low';
                    break;
                case 'high':
                    connectivityIconState = 'high';
                    break;
                default:
                    connectivityIconState = 'low';
            }

            return connectivityIconState;
        }

        function sendIceConnStateToServer(iceConnState, janusSocketState) {
            service.setLocalConnectivityState(iceConnState, janusSocketState);

            $rootScope.$broadcast('attendee-connectivity-state-changed');

            // Send 'connected' instead of 'completed' to support compatibility older mobile versions with VDI
            // ANYAM-104013, ANYAM-104014
            if (iceConnState === 'completed') {
                iceConnState = 'connected';
            }

            socketService.send({
                message: 'attendee-connectivity-updated',
                data: {
                    iceConnectionState: iceConnState
                }
            });
        }

        function getJanusVideoPublisherIceState() {
            return janusVideoPublisherIceState;
        }

        function getJanusSipCallIceState() {
            return janusSipCallIceState;
        }

        function getJanusWSConnected() {
            return janusWSConnected;
        }
        function updateJanusIceState(newState, type) {
            if (type === 'publisher') {
                janusVideoPublisherIceState = newState;
            } else if (type === 'sipcall') {
                janusSipCallIceState = newState;
            }

            $rootScope.$broadcast('janus-ice-state-updated');

            if (newState === 'disconnected') {
                analyticsWrapperService.eventTrack('meeting - janus ice - ice is restarting', {
                    category: 'janus ice restart'
                });
                iceDisconnectedTime = new Date().getTime();
            } else if (newState === 'connected' || newState === 'completed') {
                if (socketService.isConnected() && service.getJanusWSConnected()) {
                    var iceEventToTrack = {
                        category: 'janus ice connected'
                    };
                    if (iceDisconnectedTime) {
                        var iceReconnectedTime = new Date().getTime();
                        var iceReconnectTimeDifference = iceReconnectedTime - iceDisconnectedTime;
                        var iceReconnectTimeConversionToSeconds = iceReconnectTimeDifference / 1000;
                        iceEventToTrack.duration = iceReconnectTimeConversionToSeconds;
                        logger.log(
                            'meeting - ice has reconnected after: ' + iceReconnectTimeConversionToSeconds + ' seconds'
                        );
                    }
                    analyticsWrapperService.eventTrack(
                        'meeting - janus ice - ice connection connected',
                        iceEventToTrack
                    );
                }
            }
            updateDisconnectBannerVisible();
        }

        function onIceServersReceived(e, newIceServers) {
            helperService.removeDeprecatedIceServers(newIceServers);
            setIceServers(newIceServers);
        }

        function setIceServers(newIceServers) {
            iceServers = newIceServers || [];
            iceServers.unshift({ urls: 'stun:stun.l.google.com:19302' });
            logger.debug('connectivityServer iceServers=', iceServers);
        }

        function getIceServers() {
            return iceServers;
        }

        function setPhoneOnlyState() {
            isPhoneOnly = true;

            //Calling this to prevent device permissions banner from showing after its 10 second timeout
            $rootScope.$broadcast('device-permissions-rejected');

            var bannerHeader = localizationService.translate('WEBINAR_STATUS_BAR.ISSUE_CONNECING_TO_COMP.TITLE');
            var bannerContent;

            var bannerSupportLink = supportLinkService.getSupportLink('portalsEmailNew');
            if (bannerSupportLink !== 'base_url_not_available') {
                bannerContent = localizationService.translate(
                    'WEBINAR_STATUS_BAR.ISSUE_CONNECING_TO_COMP.CONTENT_URL_NOT_AVAILABLE',
                    {
                        bannerSupportLink: bannerSupportLink
                    }
                );
            } else {
                bannerContent = localizationService.translate(
                    'WEBINAR_STATUS_BAR.ISSUE_CONNECING_TO_COMP.CONTENT_URL_AVAILABLE'
                );
            }

            $rootScope.$broadcast('banner-message-show', { header: bannerHeader, content: bannerContent });

            service.setAudioThroughPhone(true, false);

            socketService.send({
                message: 'switched-audio',
                data: { type: 'telephone' }
            });
        }

        function getIsPhoneOnly() {
            return isPhoneOnly;
        }

        //Helper Functions
        function convertToPercentageString(num) {
            var percentage = (num * 100).toFixed(2);
            return percentage + '%';
        }

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        function setInitialAudioChoice(newAudioChoice) {
            audioChoice = newAudioChoice;
        }

        function getInitialAudioChoice() {
            return audioChoice;
        }

        function getIsInDeviceSelectionFlow() {
            return isInDeviceSelectionFlow;
        }

        function setIsInDeviceSelectionFlow(inDeviceSelectionFlow) {
            isInDeviceSelectionFlow = inDeviceSelectionFlow;
        }

        function setFsOriginConnectionProblem(isProblem) {
            if (isProblem) {
                onFsOriginDisconnected();
            } else {
                onFsOriginConnected();
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('deviceSelection') !== -1) {
                if (!socketService.isConnected()) {
                    service.showDisconnectedBanner();
                }
            }
        }

        function onScopeDestroyed() {
            subscriptionService.endSubscription(rootSubscription);
        }

        //#region Angular subscriptions
        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
            subscribeToState();
            subscribeToCalculatedProperties();
        }

        function subscribeToState() {
            rootSubscription.add(
                connectivityStateService.localConnectivityStatus$.subscribe(next => {
                    localConnectivityStatus = next;
                })
            );

            rootSubscription.add(
                connectivityStateService.hasLocalMediaEverBeenConnected$.subscribe(next => {
                    _hasLocalMediaEverBeenConnected = next;
                })
            );

            rootSubscription.add(
                connectivityStateService.streams$.subscribe(next => {
                    streams = next;
                })
            );

            rootSubscription.add(
                connectivityStateService.sfuStreams$.subscribe(next => {
                    sfuStreams = next;
                })
            );
        }

        function subscribeToCalculatedProperties() {
            rootSubscription.add(
                connectivityUpgradedService.streams$.subscribe(next => {
                    activeStreams = next;
                })
            );

            rootSubscription.add(
                connectivityUpgradedService.packetLossState$.subscribe(next => {
                    packetLossState = next;
                })
            );
        }

        function onCompactModeReceived(e, data) {
            isCompactMode = data;
        }

        function onUpdateMeetingActiveFeed(e, data) {
            updateDisconnectBannerVisible();
        }

        function getDisconnectBannerVisible() {
            return disconnectBannerVisible;
        }

        function getUpdatedBannerState() {
            return (
                nodeConnectivityStatus !== 'connected' ||
                !janusWSConnected ||
                (!meetingService.isWebinar() &&
                    ((!service.getAudioThroughPhone() &&
                        !(janusSipCallIceState === 'connected' || janusSipCallIceState === 'completed')) ||
                        (!attendeeService.getIsVideoMuted() &&
                            !(
                                janusVideoPublisherIceState === 'connected' ||
                                janusVideoPublisherIceState === 'completed'
                            ))))
            );
        }
        function updateDisconnectBannerVisible() {
            const prevBannerState = service.getDisconnectBannerVisible();
            const newBannerState = service.getUpdatedBannerState();
            if (prevBannerState !== newBannerState) {
                if (
                    newBannerState &&
                    meetingState !== 'ending' &&
                    !serverInitiatedDisconnect &&
                    !service.getIsInDeviceSelectionFlow()
                ) {
                    service.showDisconnectedBanner();
                    disconnectBannerVisible = true;
                } else if (!newBannerState) {
                    service.hideDisconnectedBanner();
                    disconnectBannerVisible = false;
                }
                logger.debug(
                    `#updateDisconnectBannerState: Disconnect banner visibility updated to: ${disconnectBannerVisible}`
                );
            }
        }

        //#endregion
    }
]);
